module.exports = __webpack_public_path__ + "img/cancel.9aafd961.svg";